<template>
  <div class="recharge">
    <div style="background:#111525">
      <div class="card">
        <img v-if="store.userInfo.member_level === 2" src="@/assets/vip.png" alt="" @click="data.onBridgeReady">
        <img v-else src="@/assets/member.png" alt="">
        <div class="text" :style="store.userInfo.member_level === 2?'':'color: #666666;'">{{ store.userInfo.member_level === 2?'您已经是花集AI精灵会员':'您还不是花集AI精灵会员' }}</div>
      </div>
    </div>
    <div class="main" :class="store.isSafari?'isSafariClass':''">
      <div class="itemList">
        <div class="item" :style="data.item === item?'border-color:#E6A534;background: #FFF9F0;':''" @click="data.item = item" v-for="item in data.member" :key="item.content_id">
          <div class="tip" v-if="item.label">{{ item.label }}</div>
          <div class="time">{{ data.text(item.text).time }}个月</div>
          <div class="mon"><span>¥</span>{{ data.text(item.text).mon }}<span>/月</span></div>
          <div class="price">¥{{ data.text(item.text).price }}</div>
        </div>
      </div>
      <div class="portocol">点击开通即视为同意<span style="color:#8368FC" @click="data.open()">《会员服务协议》</span></div>
      <div class="vip">
        <div class="vipHeader">VIP专享特权</div>
        <div class="headerList">
          <div class="item" v-for='item,index in data.headerList' :key="index">
            <div class="icon">
              <img v-if="index === 0" src='@/assets/icon1.png' alt="">
              <img v-if="index === 1" src='@/assets/icon2.png' alt="">
              <img v-if="index === 2" src='@/assets/icon3.png' alt="">
              <img v-if="index === 3" src='@/assets/icon4.png' alt="">
              <img v-if="index === 4" src='@/assets/icon5.png' alt="">
              <img v-if="index === 5" src='@/assets/icon6.png' alt="">
            </div>
            <div class="center">
              <div class="title">{{ item.title }}</div>
              <div class="sam">{{ item.sam }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="vipHeader">花瓣充值</div>
      <div class="itemList">
        <div class="petalItem" :style="data.item === item?'border-color:#E6A534;background: #FFF9F0;':''"  @click="data.item = item" v-for="item in data.petal" :key="item.content_id">
          <div class="tip" v-if="item.label">
            {{ item.label }}
          </div>
          <div class="prcie">
            <span>¥</span>
            {{ data.petalText(item.text).prcie }}
          </div>
          <div class="flower">
            {{ data.petalText(item.text).flower }}花瓣
          </div>
        </div>
      </div>
      <div class="bottomTip">仅充值花瓣，不升级VIP特权</div>
      <div class="bottom">
        <div class="code" @click="data.exchangePopupShow = true">
          <img src="@/assets/code.png" alt="">
          <div>兑换码入口</div>
        </div>
        <div class="btn" @click="data.pay">
          立即购买   <span v-if="data.item.type === 2">(  合计{{Number(data.petalText(data.item.text).flower)+(data.item.label?Number(data.item.label.match(/\d+/)[0]):0)  }}花瓣)</span>
        </div>
      </div>
    </div>
  </div>
  <van-popup
    v-model:show="data.exchangePopupShow"
    round
    @closed='data.code = ""'
    class="exchangePopupClass"
    close-icon="close"
    closeable
    position="bottom"
    :style="{ height: '30%' }"
  >
  <div class="title">请在下方输入获得的会员兑换码</div>
  <div class="codeInput">
    <van-field v-model="data.code" placeholder="请输入会员兑换码" />
    <div class="codeBtn" @click="data.codeClear">兑换</div>
  </div>
  </van-popup>
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed,onBeforeUnmount } from 'vue';
import { useCounterStore } from '@/store';
import { useRoute, useRouter } from 'vue-router';
import { contentList,orderOn,wxpay,exchangeCode,getPayInfo } from '@/api/recharge'
import {userInfo} from '@/api/login'
import cross from '@/assets/cross.png'  
import surres from '@/assets/surres.png'
import { showFailToast,showSuccessToast,closeToast,showLoadingToast } from 'vant';
import Cookies from 'js-cookie'
/**
* 仓库
*/
const store = useCounterStore();
/**
* 路由对象
*/
const route = useRoute();
/**
* 路由实例
*/
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
* 数据部分
*/
const data = reactive({})
data.num = 0
data.time = null
data.userInfo = JSON.parse(localStorage.getItem('userInfo'))
data.member = []
data.petal = []
data.item = {}
data.code = ''
data.headerList = [
  {
    title:'每月赠送1000花瓣',
    sam:'开通即送，按月到账'
  },
      {
    title:'文案类应用五折',
    sam:'优惠价助你自由创作'
  },
    {
    title:'自定义绘图五折',
    sam:'优惠价助你自由创作'
  },
  //   {
  //   title:'记录永久保存',
  //   sam:'每一次自动保存'
  // },
    {
    title:'作品非公开',
    sam:'默认放入私人画夹'
  },
    {
    title:'新应用优先体验',
    sam:'功能持续更新中'
  },

]

data.exchangePopupShow = false
data.codeClear = () => {
  if (data.code) {
    exchangeCode({
      user_id:data.userInfo.id,
      coupon_code:data.code
    }).then(res=>{
      showSuccessToast({
        message:res.message,
        icon:surres
      })
      store.getUserinfo(data.userInfo.id)
      data.exchangePopupShow = false
      data.code = ''
    })
  } else {
    showFailToast({
      message:'请输入会员兑换码',
      icon:cross
    })
  }
}

data.contentList = () =>{
  contentList().then(res=>{
    if (res.code === 200) {
      data.member = res.data.member
      data.petal = res.data.petal
    }
  })
}

data.text = (e) =>{
  let parmas = {
    time:e.split(',')[0],
    mon:e.split(',')[1],
    price:e.split(',')[2]
  }
  return parmas
}

data.petalText = (e) =>{
  let parmas = {
    prcie:e.split(',')[0],
    flower:e.split(',')[1]
  }
  return parmas
}

data.pay = () =>{
  showLoadingToast({
    message: '加载中...',
    forbidClick: true,
  });
  if (data.item.content_id) {
    let pay_content = {}
    const userInfo = localStorage.getItem('userInfo')
    orderOn({
      user_id:JSON.parse(userInfo).id,
      content_id:data.item.content_id
    }).then(res=>{
      if (store.WxFlage) {
        pay_content = {api_type:1}
        let openid = localStorage.getItem('openid')
        let code = Cookies.get('code');
        if (openid) {
          pay_content.openid = openid
        } else {
          pay_content.code = code
        }
        data.wxpayFunction(res.data,pay_content)
      } else {
          pay_content = {
            api_type:3,
            type:'H5'
          }
          data.wxpayFunction(res.data,pay_content)
      }
    })
  }
}

data.wxpayFunction = (no,pay_content) => {
  wxpay({
    source_type:1,  
    trade_no:no,
    pay_content:pay_content
  }).then(wxParms=>{
    closeToast();
    if (wxParms.code === 200) {
      if (store.WxFlage) {
      localStorage.setItem('openid',wxParms.data.open_id)
      localStorage.setItem('pay',true)
        WeixinJSBridge.invoke('getBrandWCPayRequest', { ...wxParms.data.weipay},    
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
              alert('支付成功!');
            userInfo({user_id:data.userInfo.id}).then(user=>{
              if (user.code === 200) {
                store.setUserInfo(user.data)
                localStorage.setItem('userInfo',JSON.stringify(user.data))
              }
            })
            return false
          } else {
            localStorage.setItem('pay',false)
            showFailToast({
              message:'用户取消支付',
              icon:cross
            })
          }
      });
      } else {
        localStorage.setItem('H5Pay',no)
        data.num = 0
        data.time  = setInterval(()=>{
          data.num  = data.num  + 1
          getPayInfo({trade_no:no}).then(res=>{
            if (res.data.status === 2) {
              showSuccessToast({
                message:'支付成功',
                icon:surres
              })
              userInfo({user_id:data.userInfo.id}).then(user=>{
                if (user.code === 200) {
                  store.setUserInfo(user.data)
                  localStorage.setItem('userInfo',JSON.stringify(user.data))
                }
              })
              clearInterval(data.time)
            } else if(res.data.status === 3 || data.num === 30){
              showFailToast({
                message:'用户取消支付',
                icon:cross
              })
              clearInterval(data.time)
            }
          })
        },1000)
        window.location.href = wxParms.data.weipay
      }
    }
  })
}

data.open = () =>{
  window.open('https://huajiwang.feishu.cn/wiki/N5xuwmwDFimV5WkXZqUcTa98nUK')
}

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
})
onBeforeUnmount(()=>{
  clearInterval(data.time)
})
onMounted(() => {
  data.contentList()
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
})
watchEffect(()=>{
})
// 使用toRefs解构
// let { } = { ...toRefs(data) } 
defineExpose({
  ...toRefs(data)
})

</script>
<style lang='scss' scoped>
.recharge{
  overflow-y: auto;
  height:100vh;
  background: #FFFFFF;
}
.isSafariClass{
  // height: calc(100vh - 550px) !important;
}
.tip{
  font-weight: 300;
  color: #FFFFFF;
  font-size: 28px;
  padding: 32px;
}
.card{
  background: url('~@/assets/flower.png') no-repeat;
  background-position: top right;
  background-size: 176px 176px;
  background-color: #DED7FD;
  border-radius: 48px;
  padding: 32px;
  margin: 0 24px;
  padding-top: 20px;
  .cardHeader{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .code{
      font-size: 28px;
      text-align: center;
      border-radius: 26px;
      color: #8368FC;
    }
  }
  img{
    width: 106px;
    height: 40px;
  }
  .text{
    margin-top: 16px;
    font-size: 32px;
    color: #8368FC;
    margin-bottom: 119px;
  }
}
.main{
  // overflow-y:  auto;
  position: relative;
  background: #FFFFFF;
  top: -119px;
  border-radius: 48px 48px 0px 0px;
  .headerList{
    margin-top: 20px;
    padding:0 10px;
    display: grid;
    grid-template-columns:340px 340px 340px;
    grid-gap: 24px;
    overflow-y: auto;
    .item{
      padding: 20px;
      background: #F7F5FF;
      border-radius: 24px;
      display: flex;
      align-items: center;
      .icon{
        margin-right: 12px;
        img{
          width: 64px;
          height: 64px;
        }
      }
      .center{
        .title{
          font-size: 26px;
          font-weight: 500;
          color: #222222;
        }
        .sam{
          font-size: 24px;
          font-weight: 300;
          color: #666666;
        }
      }
    }
  }
  .headerList::-webkit-scrollbar {
    display: none;
  }
  .itemList{
    padding:0 53px;
    padding-top: 37px;
    display: flex;
    justify-content: space-between;
    .petalItem{
      width: 180px;
      height: 215px;
      border-radius: 24px;
      border: 3px solid #EEEEEE;
      text-align: center;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      .tip{
        position: absolute;
        top: -1px;
        right: 0;
        background: #8368FC;
        border-radius: 0px 16px 0px 16px;
        font-weight: 400;
        color: #FFFFFF;
        font-size: 22px;
        padding: 4px 10px;
      }
      .prcie{
        font-weight: 600;
        color: #E6A534;
        font-size: 48px;
        font-family: DINAlternate-Bold;
        span{
          font-size: 22px;
        }
      }
      .flower{
        margin-top: 7px;
        font-weight: 400;
        color: #8368FC;
        font-size: 24px;
      }
    }
    .item{
      width: 180px;
      height: 215px;
      border-radius: 24px;
      border: 3px solid #EEEEEE;
      text-align: center;
      position: relative;
      box-sizing: border-box;
      .tip{
        position: absolute;
        top: -1px;
        right: 0;
        background: #8368FC;
        border-radius: 0px 16px 0px 16px;
        font-weight: 400;
        color: #FFFFFF;
        font-size: 22px;
        padding: 4px 10px;
      }
      .time{
        font-weight: 600;
        color: #222222;
        font-size: 30px;
        margin-top: 44px;
      }
      .mon{
        margin-top: 16px;
        font-weight: 600;
        color: #E6A534;
        font-size: 40px;
        span{
          margin: 3px;
          font-size: 22px;
        }
      }
      .price{
        margin-top: 17px;
        color: #8368FC;
        font-size: 24px;
      }
    }
  }
  .portocol{
    margin-top: 20px;
    font-size: 24px;
    font-weight: 400;
    color: #666666;
    padding-left: 48px;
  }
  .vipHeader{
    margin-top: 28px;
    padding-left: 48px;
    font-size: 32px;
    color: #222222;
    font-weight: 500;
  }
}
.bottomTip{
  font-size: 24px;
  margin-left: 54px;
  font-weight: 400;
  color: #666666;
  padding-top: 24px;
  margin-bottom: 120px;
}
.bottom{
    position: fixed;
  bottom: 0;
  width: 100%;
  background: #FFFFFF;
  padding: 20px;
  box-shadow: 0px -5px 5px 0px rgba(0,0,0,0.06);
  display: flex;
  justify-content: space-evenly;
  .code{
    text-align: center;
    color: #222222;
    font-size: 24px;
    img{
      width: 48px;
      height: 48px;
    }
  }
}
.btn{
  // margin: auto;
  width: 500px;
  height: 88px;
  line-height: 88px;
  background: #8368FC;
  border-radius: 49px;
  font-weight: 500;
  color: #FFFFFF;
  font-size: 32px;
  text-align: center;
}
</style>
<style >
:root{
  --van-field-placeholder-text-color:#969799;
}
</style>